<template>
  <wo-card :title="title">
    <form autocomplete="false">
      <wo-properties mod-horizontal mod-bordered v-focus="true">
        <template v-for="prop in properties">
          <wo-properties-label :key="prop.id"><wo-label v-t="prop.labelKey"></wo-label></wo-properties-label>
          <wo-properties-value :key="prop.labelKey">
            <po-input-field v-model="pending[prop.id]" />
            <po-input-field v-if="prop.local" v-model="pending.localized[prop.id]" messageKey="general.localName" />
          </wo-properties-value>
        </template>
      </wo-properties>
      <wo-layout>
        <po-confirmation-buttons @cancel="dismiss" @confirm="confirm" :valid="true" />
      </wo-layout>
    </form>
  </wo-card>
</template>

<script>

import _ from 'lodash'

import modal from '@/mixins/modal'

import { Address } from '@/model/company'
import { Enums } from '@/model/util'

export default {
  mixins: [ modal ],
  props: {
    value: Address
  },
  data () {
    return {
      pending: undefined
    }
  },
  created () {
    this.pending = new Address(this.value)
  },
  computed: {
    title () {
      return this.$t('address.editTitle')
    },
    properties () {
      return [
        this.prop('street', 'address.street'),
        this.prop('street_number', 'address.streetNumber'),
        this.prop('city', 'address.city'),
        this.prop('postal_code', 'address.postalCode'),
        this.prop('administrative_area_1', 'address.area1'),
        this.prop('administrative_area_2', 'address.area2'),
        this.prop('country', 'address.country')
      ]
    }
  },
  methods: {
    prop (id, labelKey) {
      return Enums.value(id, labelKey, {
        local: _.some(_.keys(Address.local), p => id === p)
      })
    },
    confirm ({ detail }) {
      this.close(new Address(this.pending))
      detail.resolve()
    }
  }
}
</script>
